import React, { useEffect, useState } from "react";
import { apiService } from "../../constants/ApiService";
import { Card, CardBody } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const GetExcelExportTblConfig = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

  // 🔍 Search & Filters
  const [search, setSearch] = useState("");
//   const [moduleName, setModuleName] = useState("");
//   const [isActive, setIsActive] = useState("");

  const onHandleEdit = (id) => {
    const selected = data.find((x) => x.id === id);
    navigate('/SaveExcelExportTblConfig', { state: { ...(selected || {}) } });
  };

   const onHandleDelete = async (id) => {
      const isDeleteConfirmed = window.confirm(
        'Are you sure you want to delete this item?'
      );
      if (isDeleteConfirmed) {
        try {
          let config = {
            headers: {
              'Content-Type': 'application/json', // Important for file uploads
              accept: 'application/json',
            },
          };
  
          const response = await apiService.delete(
            `/api/ExcelExportConfiguration/DeleteExportTable?id=${id}`,
            config
          );
          if (response.response && response.response.data.errors) {
            toast.error(response.response?.data?.errors);;
          }
  
          if (response.status === true) {
            toast.success(response.message);
            fetchExportTables();
          } else {
            toast.error(response.message);
          }
        } catch (error) {
          console.log(error);
          alert('Something went wrong');
        }
      } else {
        console.log('Deletion canceled.');
      }
    };

  useEffect(() => {
    fetchExportTables();
  }, [search]);

  const fetchExportTables = async () => {
    setLoading(true);

    try {
      const res = await apiService.get(
        "api/ExcelExportConfiguration/GetAllExportTables?search=" + search,
      );
      if (res.status) {
        setData(res.dataList);
      } else {
        alert(res.message);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchExportTables(e.target.value);
  };

  return (
    <>
    
      <div className='text-right mb-2'>
        <Link to="/SaveExcelExportTblConfig" className='btn btn-primary'>
          <i className='bi bi-plus-circle' /> Add New
        </Link>
      </div>
     <Card className='card-box pd-20 mb-20'>
      <h5 className="mb-3">Export Table Configuration List</h5>

      {/* 🔍 Search Section */}
      <CardBody>
      <form className="row g-2 mb-3">
        <div className="col-md-12">
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* <div className="col-md-3">
          <input
            type="text"
            className="form-control"
            placeholder="Module Name"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
          />
        </div> 

        <div className="col-md-2">
          <select
            className="custom-select"
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
          >
            <option value="">All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>

        <div className="col-md-3">
          <button className="btn btn-primary w-100">
            Search
          </button>
        </div>*/}
      </form>

      {/* 📋 Table */}
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead className="text-white bg-primary">
            <tr>
              <th>#</th>
              <th></th>
              <th>Table Name</th>
              <th>Display Name</th>
              <th>Module</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : data.length < 0 ? (
              <tr>
                <td colSpan="6" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                      <i
                        className='bi bi-pencil mr-2 text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(item.id)}
                      />
                      <i
                        className='bi bi-trash text-danger'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleDelete(item.id)}
                      />
                    </td>
                  <td>{item.tbl_name}</td>
                  <td>{item.display_name}</td>
                  <td>{item.module_name}</td>
                  <td>
                    {item.is_active === 1 ? (
                      <span className="badge bg-success">Active</span>
                    ) : (
                      <span className="badge bg-danger">Inactive</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      </CardBody>

    </Card>

    
    </>
  );
};

export default GetExcelExportTblConfig;
